import { connect } from 'react-redux';

import { Sidebar } from "./Sidebar";

import {
  canSortResults,
  getResetButtonText,
  getSecondaryFilters, 
  getSecondaryFilterLabel, 
  getSortOptions,
} from '../../store/filters/selectors';

import {
  addFilter,
  removeFilter,
  resetFilter,
  updateFilter,
  updateSort,
} from "../../store/search/actions";

const mapStateToProps = state => {  
  return ({
    heading: getSecondaryFilterLabel(state),
    filters: getSecondaryFilters(state),
    resetButtonText: getResetButtonText(state),
    sortOptions: getSortOptions(state),
    canSortResults: canSortResults(state),
  }); 
};

const mapDispatchToProps = dispatch => ({
  addFilter: o => dispatch(addFilter(o)),
  removeFilter: o => dispatch(removeFilter(o)),
  updateFilter: o => dispatch(updateFilter(o)),
  resetFilter: o => dispatch(resetFilter(o)),
  updateSort: o => dispatch(updateSort(o)),
});

export const SidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);
